var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 628.72 227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003;}.cls-2{fill:url(#Degradado_sin_nombre_26);}.cls-3{fill:url(#Degradado_sin_nombre_26-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_26",
    x1: 11.62,
    y1: 203.37,
    x2: 120.8,
    y2: 37.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3cdeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3bd9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#37cbdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#30b3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2892af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#1c688b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0e3560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_26-2",
    x1: 19.15,
    y1: 208.32,
    x2: 128.33,
    y2: 42.29,
    xlinkHref: "#Degradado_sin_nombre_26"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.3,105.26H276.15a43.84,43.84,0,0,1-43.83-43.84v-58a2,2,0,0,1,2-2h25.09a2,2,0,0,1,2,2V56.81a24.25,24.25,0,0,0,24.25,24.24h6.58a2,2,0,0,1,2,2v20.15A2,2,0,0,1,292.3,105.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.77,105.26a2,2,0,0,1-2-2V3.42a2,2,0,0,1,2-2h25.11a2,2,0,0,1,2,2v99.81a2,2,0,0,1-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M461.39,103.2a2,2,0,0,1-2,2.06h-26.2a2,2,0,0,1-2-2c-.56-23.74-11.23-35.45-30.52-36.62v36.59a2,2,0,0,1-2,2H373.5a2,2,0,0,1-2-2V3.42a2,2,0,0,1,2-2h25.09a2,2,0,0,1,2,2V40c19.29-1.17,30-12.89,30.52-36.62a2,2,0,0,1,2-2h26.2a2,2,0,0,1,2,2.06c-.54,25.87-11.42,41.22-24.1,49.87C450,62,460.84,77.33,461.39,103.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M483.89,103.23V3.42a2,2,0,0,1,2-2h61a2,2,0,0,1,2,2V24.14a2,2,0,0,1-2,2H513V40.94h29.28a2,2,0,0,1,2,2V63.69a2,2,0,0,1-2,2H513V80.49H547a2,2,0,0,1,2,2v20.72a2,2,0,0,1-2,2h-61A2,2,0,0,1,483.89,103.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329,122.12a2,2,0,0,1,2-2h49.32c17,0,30.8,11.94,30.8,37.2s-13.78,37.19-30.79,37.19H358.18v27.45a2,2,0,0,1-2,2H331a2,2,0,0,1-2-2Zm52.72,35.17c0-8.06-4.79-12.92-10.7-12.92H359.18a1,1,0,0,0-1,1V169.2a1,1,0,0,0,1,1H371C377,170.21,381.74,165.34,381.74,157.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507.16,223.38a2.07,2.07,0,0,1-2.07,2.11h-26.9a2,2,0,0,1-2-2c-.61-17-9.11-25.74-22.48-26.62a0,0,0,0,0,0,0v26.51a2.07,2.07,0,0,1-2.07,2.07h-25a2.07,2.07,0,0,1-2.06-2.07V122.16a2.07,2.07,0,0,1,2.06-2.07h49.28c17,0,30.8,11.94,30.81,37.2,0,14.86-4.81,25.07-12.21,31C502,196.91,506.74,208.63,507.16,223.38Zm-53.52-54.12a1,1,0,0,0,1,.94h11.86c5.91,0,10.7-4.52,10.7-12s-4.79-12-10.7-12H454.65a1,1,0,0,0-1,.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M628.72,172.78c0,29.94-24.62,54.22-55,54.22s-55-24.27-55-54.22,24.63-54.24,55-54.24S628.72,142.83,628.72,172.78Zm-29.83,0a25.18,25.18,0,1,0-25.17,24.82A25,25,0,0,0,598.89,172.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.85,121.48a1.77,1.77,0,0,1,1.77,1.77v58.8a1.77,1.77,0,0,1-1.77,1.77H272.12v-.13a32.54,32.54,0,1,1,0-62.09v-.12Zm-24.36,31.17a9.11,9.11,0,1,0-9.11,9.11A9.12,9.12,0,0,0,271.49,152.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 231.99,
    y: 202.94,
    width: 65.09,
    height: 19.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.26,43.64A89.71,89.71,0,0,0,107.21,0H43.64A43.64,43.64,0,0,0,0,43.64H101.31c.71,0,1.42,0,2.13,0s1.43,0,2.13,0C138.35,45.13,162.2,80.9,142.1,116c-6.23,10.87-21.65,19.73-34.19,19.73H99.56v43.68h0a55.91,55.91,0,0,1-55.92-55.92V65.75H0v64.49A92.76,92.76,0,0,0,92.76,223h6.8V179.41h4.67c1,0,2,0,3,0a89.68,89.68,0,0,0,74.05-43.63l0,0a89.82,89.82,0,0,0,0-92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 97,
    cy: 89.93,
    r: 21.62
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/full-logo.70a244658fc2793edcc0ccf85a7e5cd3.svg";
export { ForwardRef as ReactComponent };